module.exports = __webpack_public_path__ + "static/gorilla-38cfc87d180087b078eb020e90472b67.svg";